import { render, staticRenderFns } from "./VueAvatar.vue?vue&type=template&id=7d81a7b3"
import script from "./VueAvatar.vue?vue&type=script&lang=js"
export * from "./VueAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports